const API_ROOT = '/api/investors'

export const getInvestorsUrl = () => `${API_ROOT}/investors`

export const getInvestorUrl = ( investorId ) => `${API_ROOT}/investor/${investorId}`
